import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as AuthActions from '../actions/authActions';

import * as store from '../../api/localStore';

import Login from '../components/login';
import Confirm from '../components/confirm';
import SetPassword from '../components/setPassword';
import ResetPassword from '../components/resetPassword';
import MobileNumberVerification from '../components/mobileNumberVerification';
import EasyLogin from '../components/easyLogin';
import AutoLogin from '../components/autoLogin';
import ClientSelction from '../components/clientSelection';
import Controls from '../../util/controls';

class AuthPage extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    
  }

  onLogin = (values) => {
    this.props.actions.login(values);
  }

  onEasyLogin = (values) => {
    this.props.actions.easyLogin(values);
  }

  onConfirm = (values) => {
    this.props.actions.confirmAccount(values);
  }
  
  onProfileUpdate = (values) => {
    this.props.actions.updateProfile(values);
  }

  onLogout = () => {
    this.props.actions.logout();
  }

  onLoadProfile = () => {
    this.props.actions.loadProfile();
  }

  onSelectClient = (selectedClient,username) => {
    this.props.actions.navigateToClientSite(selectedClient,username);
  }

  onMobileNumberSubmit = (mobileNumber) => {
    this.props.actions.getClients(mobileNumber);
  }

  renderLogin(username) {
    return (<Login onSubmit={this.onLogin} {...this.props} username={username} />);
  }

  renderEasyLogin() {
    return (<EasyLogin onSubmit={this.onEasyLogin} {...this.props} />);
  }

  renderAutoLogin() {
    return (<AutoLogin loginAction={this.onEasyLogin}  {...this.props} />);
  }

  renderClientSelection() {
    return (<ClientSelction onSubmit={this.onSelectClient} {...this.props} />);
  }

  renderConfrim() {
    return (<Confirm onSubmit={this.onConfirm} {...this.props} />);
  }

  renderProfile() {
    return (<Profile onSubmit={this.onProfileUpdate} handleLogout={this.onLogout} loadProfile={this.onLoadProfile} {...this.props} />);
  }

  renderSetPassword() {
    return (<SetPassword onSubmit={this.props.actions.setPassword} {...this.props} />);
  }

  renderResetPassword() {
    return (<ResetPassword onSubmit={this.props.actions.resetPassword} {...this.props} />);
  }

  renderPreFilter() {
    return (<MobileNumberVerification onSubmit={this.props.actions.getClientList} {...this.props} />);
  }

  render() {
    let { mode, username } = this.props.location.query;

    let componentToRender = null;

    if (this.props.ajaxCallCount > 0)
      return <Controls.LoadingPanel />;
    else {
      switch (mode) {
        case "confirm":
          componentToRender = this.renderConfrim();
          break;
        case "setpassword":
          componentToRender = this.renderSetPassword();
          break;
        case "resetpassword":
          componentToRender = this.renderResetPassword();
          break;
        case "easylogin":
          componentToRender = this.renderEasyLogin();
          break;
        case "autologin":
          componentToRender = this.renderAutoLogin();
          break;
        case "clientselection":
          componentToRender = this.renderClientSelection();
          break;
        case "mobileverification":
          //componentToRender = this.renderPreFilter();
          browserHistory.push("/contactus");
          break;
        default:
          // mode = "login";
          // componentToRender = this.renderLogin(username);
          browserHistory.push("/contactus");
          break;
      }
      return (
        <div className="Auth">
          {componentToRender}
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    core: state.core,
    ajaxCallCount: state.core.ajaxCallCount,
    auth: state.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(AuthActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthPage);



// WEBPACK FOOTER //
// ./app/auth/containers/authPage.js